import { Api } from "./Api.class";
const endpoint = "tests";
const TestsAPI = new Api(endpoint);
export default TestsAPI;
